import { useEffect, useState } from "react";
import { api, imageUrl } from "@/lib/api";
import { useChampionship } from "@/context/ChampionshipContext";

const TIER_LABELS = {
  main: "Main Partners",
  partner: "Official Partners",
  supporter: "Supporters",
};
const TIER_ORDER = ["main", "partner", "supporter"];

export default function PartnersPage() {
  const { current } = useChampionship() || {};
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    if (!current?.id) return;
    api.get(`/championships/${current.id}/sponsors`).then((r) => setSponsors(r.data || []));
  }, [current?.id]);

  const grouped = TIER_ORDER.map((tier) => ({
    tier,
    label: TIER_LABELS[tier] || tier,
    items: sponsors.filter((s) => (s.tier || "partner") === tier),
  })).filter((g) => g.items.length > 0);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="partners-page">
      <div className="border-b border-border pb-10 mb-12">
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
          {current?.year} — {current?.location}
        </div>
        <h1 className="font-display text-5xl md:text-7xl font-extrabold tracking-tighter mt-3">Partners</h1>
        <p className="mt-4 text-muted-foreground max-w-2xl">
          The World Othello Championship is made possible by the support of our partners.
        </p>
      </div>

      {sponsors.length === 0 ? (
        <div className="text-muted-foreground" data-testid="partners-empty">No partners listed yet.</div>
      ) : (
        grouped.map((g) => (
          <section key={g.tier} className="mb-16" data-testid={`partners-tier-${g.tier}`}>
            <div className="text-[11px] uppercase tracking-[0.25em] text-primary mb-6">{g.label}</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
              {g.items.map((s) => (
                <a
                  key={s.id}
                  href={s.url || "#"}
                  target={s.url ? "_blank" : undefined}
                  rel="noreferrer"
                  className="group flex flex-col items-center justify-center border border-border bg-white aspect-[5/3] p-6 hover:-translate-y-0.5 hover:shadow-md transition-all"
                  data-testid={`partner-card-${s.id}`}
                >
                  {s.logo_path ? (
                    <img src={imageUrl(s.logo_path)} alt={s.name} className="max-h-16 max-w-full object-contain transition" />
                  ) : (
                    <span className="font-display text-lg font-semibold tracking-tight text-center">{s.name}</span>
                  )}
                  <div className="mt-3 text-xs text-muted-foreground text-center">{s.name}</div>
                </a>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
}
